/**
 * dopa-header-progress.js  v3
 * Uses position:absolute inside .navbar to avoid breaking the flex layout.
 * The header__menu-wrp has flex:1 which eats all space — absolute positioning
 * is the only reliable way to center the bar without touching header.liquid.
 */

const TIER2_VND = 2_500_000;

function fmt(vnd) {
  return vnd.toLocaleString('vi-VN') + 'đ';
}

function injectCSS() {
  if (document.getElementById('dopa-hpb-css')) return;
  const s = document.createElement('style');
  s.id = 'dopa-hpb-css';
  s.textContent = `
    /* Hide the FAQ nav link from header on desktop */
    @media (min-width: 992px) {
      .header__menu-wrp { display: none !important; }
    }

    /* Progress bar - absolute centered in navbar */
    .header .navbar { position: relative; }

    #dopa-hpb { display: none; }
    @media (min-width: 992px) {
      #dopa-hpb {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        z-index: 1;
        pointer-events: none;
      }
      #dopa-hpb .hpb-inner {
        pointer-events: auto;
        background: rgba(209, 250, 229, 0.95);
        border-radius: 10px;
        padding: 7px 14px;
        display: flex;
        flex-direction: column;
        gap: 5px;
      }
      #dopa-hpb .hpb-msg {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        margin: 0;
        line-height: 1.3;
        color: #111;
        font-family: inherit;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      #dopa-hpb .hpb-msg strong { color: #C1440E; font-weight: 700; }
      #dopa-hpb .hpb-track {
        position: relative;
        height: 7px;
        background: #d1d5db;
        border-radius: 99px;
        overflow: hidden;
      }
      #dopa-hpb .hpb-fill {
        position: absolute;
        top: 0; left: 0; height: 100%;
        background: #C1440E;
        border-radius: 99px;
        transition: width 0.4s ease;
      }
      #dopa-hpb .hpb-sep {
        position: absolute;
        top: 0; left: 40%;
        height: 100%; width: 2px;
        background: #fff; z-index: 2;
      }
    }
  `;
  document.head.appendChild(s);
}

function injectHTML() {
  if (document.getElementById('dopa-hpb')) return;
  const navbar = document.querySelector('.header .navbar');
  if (!navbar) {
    console.warn('[dopa-hpb] .header .navbar not found');
    return false;
  }
  const div = document.createElement('div');
  div.id = 'dopa-hpb';
  div.innerHTML = `
    <div class="hpb-inner">
      <p class="hpb-msg">Đang tải...</p>
      <div class="hpb-track">
        <div class="hpb-fill" style="width:0%"></div>
        <div class="hpb-sep"></div>
      </div>
    </div>
  `;
  navbar.appendChild(div);
  return true;
}

function updateUI(totalVND) {
  const bar = document.getElementById('dopa-hpb');
  if (!bar) return;

  if (totalVND <= 0) {
    bar.style.display = 'none';
    return;
  } else {
    bar.style.display = 'block';
  }

  const msg = '✓ Miễn phí vận chuyển tiêu chuẩn & thêu từ đơn đầu';
  bar.querySelector('.hpb-msg').innerHTML = msg;
  bar.querySelector('.hpb-fill').style.width = '100%';
}

async function run() {
  try {
    injectCSS();
    injectHTML();
    const res = await fetch('/cart.js');
    const cart = await res.json();
    // Shopify total_price is in cents → divide by 100 for VND
    updateUI(cart.total_price / 100);
  } catch (e) {
    console.warn('[dopa-hpb] error:', e);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', run);
} else {
  run();
}

document.addEventListener('cart:refresh', run);
document.addEventListener('cart:update', run);
